import React from 'react'
import { BsInfoCircleFill } from 'react-icons/bs'
import PageHeaderComponent from '../../components/pageHeader'
import './styles.scss'

import { RiFlutterFill } from 'react-icons/ri'
import { SiDart, SiPostgresql, SiMysql, SiFirebase, SiMongodb, SiFastapi, SiLeaflet, SiFlask, SiClickhouse, SiCplusplus } from 'react-icons/si'
import { FaJava, FaGithub, FaNodeJs, FaJs, FaPython, FaReact, FaRust, FaLinux, } from 'react-icons/fa'



const databaseIcons = [
    {
        name: "PostgreSQL",
        icon: SiPostgresql
    },
    {
        name: "MySQL",
        icon: SiMysql
    },
    {
        name: "Firebase",
        icon: SiFirebase

    },
    {
        name: "MongoDB",
        icon: SiMongodb
    },
    {
        name: "Clickhouse",
        icon: SiClickhouse
    }
]

const techIcons = [
    {
        name: "Flutter",
        icon: RiFlutterFill
    },
    {
        name: "FastAPI",
        icon: SiFastapi
    },
    {
        name: "Leaflet",
        icon: SiLeaflet
    },
    {
        name: "Flask",
        icon: SiFlask
    },
    {
        name: "GitHub",
        icon: FaGithub
    },
    {
        name: "NodeJS",
        icon: FaNodeJs
    },
    {
        name: "React",
        icon: FaReact
    },
    {
        name: "Linux",
        icon: FaLinux
    }
]

const languageIcons = [
    {
        name: "JavaScript",
        icon: FaJs
    },
    {
        name: "Python",
        icon: FaPython
    },
    {
        name: "Dart",
        icon: SiDart
    },
    {
        name: "C++",
        icon: SiCplusplus
    },
    {
        name: "Rust",
        icon: FaRust
    },
    {
        name: "Java",
        icon: FaJava
    }
]

const allIcons = [...languageIcons, ...techIcons, ...databaseIcons]

const summary = "I am Pranav, a Software Engineer from India! I am currently working on a project at the Indian Space Research Organization. I have coded in over 11 languages and have used different techstacks over my computer science degree from Shiv Nadar University. I love to work on new stuff and currently I am exploring the Web3 domain and constantly improving my problem solving skills. And yes, I am actively looking for challenging and rewarding roles from coming June."

const personalInfo = [
    {
        label: 'Name',
        value: 'Pranav Soni'
    },
    {
        label: 'Age',
        value: '23'
    },
    {
        label: 'Email',
        value: 'pranav.bhawan@gmail.com'
    },
    {
        label: 'LinkedIn',
        value: 'https://www.linkedin.com/in/ps428/'
    },
    {
        label: 'GitHub',
        value: 'https://www.github.com/ps428'
    }
]

const skillsTag = ['languages', 'tech', 'databases', 'tools']

const skillsBox = (skillTag) => {
    return <div>
        <h3>{skillTag}</h3>

    </div>
}

const skills = () => {
    return <section className="skills">
        <h2>Broad Categorization</h2>
        <ul>
            <li>
                <span>Backend</span>
                <div className="bar backend"></div>
            </li>
            <li>
                <span>Frontend</span>
                <div className="bar frontend"></div>
            </li>
            <li>
                <span>Databases</span>
                <div className="bar databases"></div>
            </li>
        </ul>
    </section>

}

const Skills = () => {
    return (
        <section id="skills" className='skill'>
            <PageHeaderComponent
                headerText="Skills"
                icon={<BsInfoCircleFill size={40} />}
            />
            <p>Only this page is under development, thinking of a cool way to showcase my skillset. Please note this part might take some time, I am thinking of providing the stats of all my code work done over time, probably showing the lines of code used in each language, and in each framework to show the real value of my skills. I am working along libraries like pygount to serve my purpose.</p>
            <div className=''>

                {/* {
            skillsTag.map((skillTag, index) => {
                return <div key={index}>
                    {skillsBox(skillTag)}
                </div>
            }
            )
        } */}

                <div className="row">
                    {skills()}
                </div>
                <div className="icons">
                    {
                        allIcons.map((icon, index) => {
                            return (
                                <div key={index} >
                                    <icon.icon size={40} />
                                </div>
                            )
                        })
                    }
                </div>
            </div>
        </section>
    )
}

export default Skills;